/* eslint-disable @typescript-eslint/member-ordering */
import { selectAgency } from './../../../../core/profiles/profiles.selectors';
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { formatArrivalDate } from '../../../../utils/Functions';
import { checkOutHotel } from './checkOutHotel';
import { MatDialog } from '@angular/material/dialog';
import { NrBlockModalComponent } from '../../../../shared/nr-block-modal/nr-block-modal.component';
import { UserService } from '../../../../pages/com.usblick.common/auth/user.service';
import { Router } from '@angular/router';
import { ItineraryService } from '../../../../shared/itinerary.service';
import { Observable, of } from 'rxjs';
import { RestService } from '../../../../shared/rest.service';
import { ResearchService } from '../../../../shared/research.service';
import { setting } from '../../../../../../setting';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { MaterialModalAlertComponent } from 'app/shared/material-modal-alert/material-modal-alert.component';
import * as moment from 'moment';
import 'moment/locale/es';
import { ModalLoadingComponent } from 'app/shared/modal-loading/modal-loading.component';
import { ResultsSearchService } from 'app/home/results-search.service';
import { HttpErrorResponse } from '@angular/common/http';
import CssFilterConverter from 'css-filter-converter';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { DestinationImageService } from '../../../../core/services/destination-image.service';
moment.locale('es');
enum ECategoryName {
  Hotels = 'HOTELS',
  Transports = 'TRANSPORTS',
  Tours = 'TOURS',
  Disney = 'DISNEY',
  Rentacar = 'RENT-A-CAR',
  Ptheme = 'PTHEMES',
  Insurance = 'INSURANCE',
  Flights = 'FLIGHTS',
}

interface IItemItinerary {
  date: Date;
  position: number;
  checkout: boolean;
}

@Component({
  selector: 'usb-destiny-summary',
  templateUrl: './destiny-summary.component.html',
  styleUrls: ['./destiny-summary.component.scss'],
  providers: [DynamicFontSizePipe, DestinationImageService],
})
export class DestinySummaryComponent implements OnInit, OnDestroy {
  @Input() actualItinerary: any;
  @Input() partialReserve: boolean;
  @Input() permissions: any[] = [];
  @Input() qtyItemsToPartial = 0;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() suggestions: any;
  @Input() netPriceAgent: number;
  @Input() summaryItinerary: any[] = [];
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() goReserveFee = new EventEmitter<any>();
  @Output() reloadSummaryItinerary = new EventEmitter();
  @ViewChildren('iconsCheckOut', { read: ElementRef }) iconsCheckOut: QueryList<ElementRef>;
  totalTarifaNeta = 0;
  totalTarifa = 0;
  totalCreditBlickoins = 0;

  // Map State — single map showing all cities
  mapVisible = false;
  mapCoordinates: any[] = [];

  totalNetPriceBooking = 0;
  totalBlickoins = 0;
  totalProviderTransports = 0;

  totalDiffNights = 0;

  public items: any[] = [];
  public showCategoryVehicle: any[] = [];
  public showCategoryTour: any[] = [6];
  public categoryName = ECategoryName;
  public formatDate = formatArrivalDate;
  roomsLoop: any[] = [];
  dataRooms: any[] = [];

  public itemHotel: checkOutHotel[];

  public heightLineTime = 0;
  public hiddenLine = true;

  public itemsDestination: any[] = [];

  itinerary$: Observable<any[]>;
  itinerary: any;

  totalTaxPrice = 0;
  totalNetPriceBookingFreeTax = 0;
  fontSizeAdjustments = { 4: 0, 6: -2, 9: -6 };

  public getClientsSettingAppBooking: any;
  getOrigin = '';
  public currencyItinerary: string;
  baseDate: Date;
  shownCombinations: Set<string> = new Set();
  bsModalRef?: BsModalRef;
  styleSidebar: any;
  styleBody: any;
  itineraryOrder: any[] = [];
  orderSummaryDestinations: any[] = [];
  clientSetting: any;
  netPriceWithIncluided = 0;
  routerStorage: any;

  paymentConditions: any;
  paymentAgencyActive: any;
  paymentAgencyActiveLoaded: any;
  filterColorIcon: any;

  /**
   * Contine el bloque de titulos generados a partir de la key destination.
   * @type {string[]}
   */
  public citiesName: string[] = [];
  // qtyItemsToPartial: number = 0;
  constructor(
    private dialog: MatDialog,
    public userService: UserService,
    private router: Router,
    public itineraryService: ItineraryService,
    public _restService: RestService,
    private reSearchService: ResearchService,
    private resultsSearch: ResultsSearchService,
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private destinationImageService: DestinationImageService
  ) {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.clientSetting = this.getClientsSettingAppBooking;
  }
  ngOnDestroy(): void {
    if (this.summaryItinerary && this.summaryItinerary.length > 0) {
      this.summaryItinerary = [];
    }
  }

  ngOnInit() {
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.getPaymentConditions(selectedAgency);
    this.routerStorage = setting.apiStorageBooking;
    this.itinerary = this.actualItinerary;
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.styleBody = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
    this.shownCombinations.clear();
    this.getOrigin = localStorage.getItem('origin');
    // this.parsedPeriod();
    // this._loadCityName();
    this._loadCheckout();
    if (this.suggestions) {
      this.suggestions.forEach((element) => {
        this.showSuggVechicle(element);
      });
    }

    const suscription = this.itineraryService.getItinerary$();
    suscription.subscribe((data: any) => {
      if (data) {
        this.actualItinerary = data[0];
        if (this.actualItinerary) {
          this.totalNetPriceBooking = this.actualItinerary.totalNetPriceBooking;
          this.totalNetPriceBookingFreeTax = this.actualItinerary.totalNetPriceBookingFreeTax;
          this.totalBlickoins = this.actualItinerary.totalBlickoins;
          this.totalCreditBlickoins = this.actualItinerary.totalCreditBlickoins;
          this.currencyItinerary = this.actualItinerary.currency;
          this.baseDate = new Date(this.userService.itineraryArrivalDateFull);
        }
        this._loadCheckout();
      }
    });

    this.itinerary.items.forEach((item: any) => {
      if (item.netPriceBookingWithIncluded) {
        this.netPriceWithIncluided = item.netPriceBookingWithIncluded;
      }
    });

    this.totalNetPriceBooking = this.actualItinerary.totalNetPriceBooking;
    this.totalBlickoins = this.actualItinerary.totalBlickoins;
    this.totalCreditBlickoins = this.actualItinerary.totalCreditBlickoins;
    this.totalTaxPrice = this.actualItinerary.totalTaxPrice;
    this.totalNetPriceBookingFreeTax = this.actualItinerary.totalNetPriceBookingFreeTax;
    this.totalProviderTransports = this.actualItinerary.totalNetPriceCategory;
    this.currencyItinerary = this.actualItinerary.currency;
    this.baseDate = new Date(this.userService.itineraryArrivalDateFull);
    // this.roomLoopItems();

    // this.orderSummary();

    this.applyImageFilter();
  }

  // parsedPeriod(): void {
  //   this.summaryItinerary.forEach((destination: any) => {
  //     destination.days.forEach((activities: any) => {
  //        return [
  //       { key: 'morning', label: 'Mañana', activities: activities.morning },
  //       { key: 'afternoon', label: 'Tarde', activities: activities.afternoon },
  //       { key: 'night', label: 'Noche', activities: activities.night }
  //       ];
  //     });
  //   });
  // }

  orderSummary(): void {
    // Paso 1: Agrupar items por destino y fecha
    const itineraryMap = new Map<string, Map<string, any[]>>();

    this.items.forEach((item: any) => {
      const destCode = item.destination?.iata_code;
      if (!destCode) {
return;
}

      const dateMap = itineraryMap.get(destCode) || new Map<string, any[]>();
      const arrivalDate = item.arrivalDate ? moment(item.arrivalDate).format('YYYY-MM-DD') : 'unknown-date';

      const activities = dateMap.get(arrivalDate) || [];
      activities.push(item);
      dateMap.set(arrivalDate, activities);
      itineraryMap.set(destCode, dateMap);
    });

    // Paso 2: Procesar cada destino
    const tempItinerary = this.actualItinerary.destination.map((destination) => {
      const destCode = destination.iata_code;
      const dateMap = itineraryMap.get(destCode) || new Map();

      // Ordenar días y procesar actividades
      const sortedDays = Array.from(dateMap.entries())
        .sort(([dateA], [dateB]) => moment(dateA).diff(moment(dateB)))
        .map(([date, activities]) => {
          // Ordenar actividades: traslados de aeropuerto primero
          const sortedActivities = activities.sort((a, b) => {
            const aIsAirport = a.category_id === 8 && a.payload?.[0]?.transfers?.pickupLocation?.type === 'airport';
            const bIsAirport = b.category_id === 8 && b.payload?.[0]?.transfers?.pickupLocation?.type === 'airport';

            if (aIsAirport && !bIsAirport) {
return -1;
}
            if (!aIsAirport && bIsAirport) {
return 1;
}
            return 0;
          });

          return {
            date: moment(date).format('DD MMM'),
            full_date: date,
            activities: sortedActivities,
          };
        });

      return {
        iata_code: destCode,
        city_name: destination.destination_info.cityName,
        days: sortedDays,
        earliest_date: sortedDays[0]?.full_date || '9999-12-31',
      };
    });

    // Paso 3: Ordenar destinos por fecha más temprana
    const sortedItinerary = tempItinerary.sort((a, b) => moment(a.earliest_date).diff(moment(b.earliest_date)));

    // Paso 4: Calcular diferencia de días y ajustar títulos
    let previousDate: moment.Moment | null = null;
    const finalItinerary = sortedItinerary.map((destination) => {
      const updatedDays = destination.days.map((day) => {
        const currentDate = moment(day.full_date);

        let dayDifference = 1;
        if (previousDate) {
          dayDifference = currentDate.diff(previousDate, 'days');
          dayDifference = dayDifference > 0 ? dayDifference + 1 : 1;
        }
        previousDate = currentDate;

        // Verificar si hay traslados de aeropuerto
        const hasAirportTransfer = day.activities.some(
          (a: any) => a.category_id === 8 && a.payload?.[0]?.transfers?.pickupLocation?.type === 'airport'
        );

        return {
          ...day,
          day_title: `Día ${dayDifference} - ${destination.city_name}`,
          has_airport_transfer: hasAirportTransfer,
        };
      });

      return {
        ...destination,
        days: updatedDays,
      };
    });

    // Eliminar propiedades temporales
    finalItinerary.map(({ earliest_date, ...rest }) => rest);

    const processedItinerary = finalItinerary.map((destination) => {
      const updatedDays = destination.days.map((day) => {
        // Buscar el primer transporte no checkout
        const transport = day.activities.find((a: any) => a.categoryName === 'TRANSPORTS' && !a.ckeckout);

        let cityDisplayName = destination.city_name;

        if (transport) {
          const origin =
            transport?.payload[0]?.transfers?.pickupLocation.type === 'hotel'
              ? transport.formTransport?.firstOrigin?.hotel_name
              : transport.formTransport?.firstOrigin?.name;
          const destinationName =
            transport?.payload[0]?.transfers?.dropoffLocation.type === 'hotel'
              ? transport.formTransport?.firstDestination?.hotel_name
              : transport.formTransport?.firstDestination?.name;
          if (origin && destinationName) {
            cityDisplayName = `${origin} > ${destinationName}`;
          }
        }

        return {
          ...day,
          day_title: day.day_title.replace(destination.city_name, cityDisplayName),
        };
      });

      return {
        ...destination,
        days: updatedDays,
      };
    });

    // Eliminar propiedades temporales y devolver resultado
    const result = processedItinerary.map(({ earliest_date, ...rest }) => rest);
    // return result;
    this.orderSummaryDestinations = result;
  }

  public showSuggVechicle(element: any) {
    let rentCar: any;
    let transport: any;
    rentCar = element.results.find((element_) => element_[0].categoryId === 2);
    transport = element.results.find((element_) => element_[0].categoryId === 8);

    if (rentCar) {
      this.showCategoryVehicle[0] = rentCar[0].categoryId;
    } else {
      if (transport) {
        this.showCategoryVehicle[0] = transport[0].categoryId;
      }
    }

    if (transport) {
      this.showCategoryVehicle[1] = transport[0].categoryId;
    } else {
      if (rentCar) {
        if (rentCar[0].categoryId !== undefined) {
          this.showCategoryVehicle[1] = rentCar[0].categoryId;
        }
      }
    }
  }

  public isCategoryNameAndDestination(iataCode: string, item: any, categoryName: string): boolean {
    if (!item.categoryName.localeCompare(categoryName)) {
      switch (categoryName) {
        case ECategoryName.Hotels:
          this.fillItemHotel(item);
          return !item.payloadUpdate.products[0].destination.localeCompare(iataCode);
        case ECategoryName.Transports:
          return !item.destination.iata_code.localeCompare(iataCode);
        case ECategoryName.Tours:
          return !item.payloadUpdate.products[0].destination.localeCompare(iataCode);
        case ECategoryName.Rentacar:
          return !item.payloadUpdate.products[0].destination.localeCompare(iataCode);
        case ECategoryName.Disney:
          return !item.destination.iata_code.localeCompare(iataCode);
        case ECategoryName.Ptheme:
          return !item.payloadUpdate.products[0].destination.localeCompare(iataCode);
        case ECategoryName.Insurance:
          return !item.payloadUpdate.products[0].destination.localeCompare(iataCode);
      }
    }
    return false;
  }

  public fillItemHotel(item: any) {
    if (!this.itemHotel) {
      this.itemHotel = [];
    }
    const ite: checkOutHotel = {
      destiny: item.destination,
      checkOutItem: item,
    };
    this.itemHotel.push(ite);
  }

  getItemCheckOutForDestination(destiny: string): any {
    let item;
    if (this.itemHotel) {
      this.itemHotel.forEach((element) => {
        if (element.checkOutItem.payloadUpdate.products[0].destination === destiny) {
          item = element.checkOutItem;
        }
      });
    }
    return item;
  }

  private _loadCityName() {
    // Ordenar destinos por posición primero
    const sortedDestinations = [...this.actualItinerary.destination].sort(
      (a, b) => a.destination_info.position - b.destination_info.position
    );
    this.citiesName = [];
    let previousCity = '';

    sortedDestinations.forEach((dest, index) => {
      const currentCity = dest.destination_info.cityName;
      if (currentCity) {
        if (index === 0) {
          if (this.actualItinerary.items[index].category_id === 8) {
            this.citiesName.push(`${currentCity} > ${sortedDestinations[index + 1].destination_info.cityName}`);
          } else {
            this.citiesName.push(currentCity);
          }
        } else {
          this.citiesName.push(`${previousCity} > ${currentCity}`);
        }
        previousCity = currentCity;
      }
    });
  }
  /**
   * construye un array de formato IItemItinerary con:
   * checkout false con arrivalDate.
   * checkout true con departureDate.
   * Luego se ordena el array en base a la fecha y por ultimo
   * crea un nuevo objeto con el orden correcto, y el flag checkout.
   * @private
   */
  private _loadCheckout() {
    this.items = [];

    if (this.actualItinerary !== undefined) {
      this.items = (<IItemItinerary[]>[
        ...this.actualItinerary.items.map((x, i) => ({
          date: new Date(x.arrivalDate),
          position: i,
          checkout: false,
        })),
        ...this.actualItinerary.items.map((x, i) => ({ date: new Date(x.departureDate), position: i, checkout: true })),
      ])
        .sort((a, b) => a.date.valueOf() - b.date.valueOf())
        .map((x) => ({ ...this.actualItinerary.items[x.position], ckeckout: x.checkout }));
    }
  }

  itemsOrderedDestination(destiny) {
    // Primero obtener los destinos ordenados por posición
    const sortedDestinations = [...this.actualItinerary.destination].sort(
      (a, b) => a.destination_info.position - b.destination_info.position
    );

    // Verificar si el destino solicitado existe
    const destExists = sortedDestinations.some((d) => d.iata_code === destiny);
    if (!destExists) {
return [];
}

    // Obtener items ordenados y filtrar por destino
    const orderedItems = this.priorityItems(this.items);
    return orderedItems.filter((item) => item.destination.iata_code === destiny);
  }

  priorityItems(items) {
    // Primero ordenar por fecha y posición de destino
    const sortedByDateAndPosition = [...items].sort((a, b) => {
      const dateCompare = new Date(a.arrivalDate).getTime() - new Date(b.arrivalDate).getTime();
      if (dateCompare !== 0) {
return dateCompare;
}

      // Si las fechas son iguales, ordenar por posición de destino
      const aDestPos =
        this.actualItinerary.destination.find((d) => d.iata_code === a.destination.iata_code)?.destination_info.position || 0;
      const bDestPos =
        this.actualItinerary.destination.find((d) => d.iata_code === b.destination.iata_code)?.destination_info.position || 0;

      return aDestPos - bDestPos;
    });

    let itemsDay = [];
    let orderItems = [];
    const allItemsOrdered = [];
    let currentDate = null;

    sortedByDateAndPosition.forEach((item, i) => {
      if (!item.ckeckout) {
        const itemDate = item.arrivalDate;

        if (currentDate === null || itemDate !== currentDate) {
          // Procesar grupo anterior
          if (itemsDay.length > 0) {
            this._processItemGroup(itemsDay, orderItems, allItemsOrdered);
            itemsDay = [];
            orderItems = [];
          }
          currentDate = itemDate;
        }

        itemsDay.push(item);
      } else {
        // Procesar checkout items
        if (itemsDay.length > 0) {
          this._processItemGroup(itemsDay, orderItems, allItemsOrdered);
          itemsDay = [];
          orderItems = [];
        }
        allItemsOrdered.push(item);
      }
    });

    // Procesar último grupo
    if (itemsDay.length > 0) {
      this._processItemGroup(itemsDay, orderItems, allItemsOrdered);
    }

    return allItemsOrdered;
  }

  private _processItemGroup(itemsDay, orderItems, allItemsOrdered) {
    itemsDay.forEach((el, j) => {
      if (j === 0) {
        orderItems.push(el);
      } else {
        switch (el.categoryName) {
          case 'TRANSPORTS':
            orderItems.unshift(el);
            break;
          case 'HOTELS':
            if (orderItems.length > 1) {
              orderItems.splice(1, 0, el);
            } else {
              const firstItem = orderItems[0];
              const isTransportOrAirportCar =
                firstItem.categoryName === 'TRANSPORTS' ||
                (firstItem.categoryName === 'RENT-A-CAR' &&
                  firstItem?.payloadUpdate?.products[0]?.others?.carRental?.pickupLocation?.origin?.toLowerCase().includes('airport'));

              isTransportOrAirportCar ? orderItems.push(el) : orderItems.unshift(el);
            }
            break;
          case 'TOURS':
            orderItems.length > 1 ? orderItems.splice(2, 0, el) : orderItems.push(el);
            break;
          case 'RENT-A-CAR':
            const isAirportPickup = el?.payloadUpdate?.products[0]?.others?.carRental?.pickupLocation?.origin
              ?.toLowerCase()
              .includes('airport');
            isAirportPickup ? orderItems.unshift(el) : orderItems.push(el);
            break;
        }
      }
    });

    orderItems.forEach((ord) => allItemsOrdered.push(ord));
  }

  _itemToPartial(qty: number) {
    this.qtyItemsToPartial = this.qtyItemsToPartial + qty;
    this.itemToPartial.emit(this.qtyItemsToPartial);
  }

  openNRNotAvailable() {
    const dialogRef = this.dialog.open(NrBlockModalComponent, {
      width: '770px',
      height: '340px',
      panelClass: 'background-modal',
    });
  }

  reSearch(event) {
    this.reSearchService.reSearch(event);
  }

  getDayCount(item: any, checkout: boolean): number {
    const dateStr = checkout ? item.departureDate : item.arrivalDate;
    const currentDate = new Date(dateStr);

    const msPerDay = 1000 * 60 * 60 * 24;
    const diffInMs = currentDate.getTime() - this.baseDate.getTime();
    const diffInDays = Math.floor(diffInMs / msPerDay);

    return diffInDays + 1;
  }

  shouldShowDayCity(day: number, city: string): boolean {
    const key = `${day}-${city}`;
    if (this.shownCombinations.has(key)) {
      return false;
    } else {
      this.shownCombinations.add(key);
      return true;
    }
  }

  resetShownCombinations(): boolean {
    this.shownCombinations.clear();
    return true;
  }

  getPositionItem(checkout: boolean): boolean {
    return true;
  }

  goToReserve() {
    const itineraryNoCancel = this.hasAvailableStatusItinerary();

    if (itineraryNoCancel) {
      this.notificationService.info('Este file fue cancelado');
      return;
    }
    this.goReserveFee.emit();
  }

  hasAvailableStatusItinerary(): boolean {
    return this.actualItinerary.status_id === 5;
  }

  getLast(item, index, last): boolean {
    return true;
  }

  deleteItem(id: string) {
    // El delete real lo hace itineraryService.remove() en el item component.
    // El parent se actualiza automáticamente via activeItinerary subscriber
    // cuando el backend confirma (remove → updateItinerary → consultActiveItinerary
    // → sendMessageActiveItinerary → activeItinerary emite → getItinerarySummary).
    // Emitimos reloadSummaryItinerary para mostrar el loading del parent mientras se procesa.
    this.reloadSummaryItinerary.emit();
    if (this.actualItinerary && this.actualItinerary.items && this.actualItinerary.items.length <= 1) {
      this.router.navigateByUrl('/home');
    }
  }

  cancelIReserve(item: any) {
    this.reloadSummaryItinerary.emit();
  }

  _removeItem(item: any) {
    let index;
    if (this.itemHotel) {
      this.itemHotel.forEach((element) => {
        if (element.checkOutItem === item) {
          const index = this.itemHotel.indexOf(element);
          return;
        }
      });
      this.itemHotel.splice(index, 1);
      this.reloadSummaryItinerary.emit();

    }
  }

  _editItem(item: any): void {
    window.scrollTo(0, 0);
    // modo quoute
    if (item.status_id == 1) {
      const message = `¿Deseas eliminar este item y buscar un nuevo hotel en ${item.location} del ${this.returnDate(
        item.arrivalDate
      )} hasta ${this.returnDate(item.departureDate)} para ${item.paxAdults} adultos`;

      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: message.replace(/\?/g, '?<br />'),
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        },
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if (result) {
          await this.makePayload(item);
          await this.itineraryService.remove(item !== undefined ? item : item);
        } else {
        }
        confirmSubscription.unsubscribe();
      });
    }
  }

  makePayload(item: any) {
    const _payload = [];

    const payload = item.payloadUpdate.products[0];
    const form = item.form;
    _payload[0] = payload;




    localStorage.setItem('form', JSON.stringify(form));
    localStorage.setItem('payload', JSON.stringify(_payload));
    this.openModalLoading(JSON.parse(localStorage.getItem('payload')));
    this._restService.doPost('app', 'search', payload).subscribe(
      (response: any) => {
        if (response !== null && response.results !== null) {
          const payloadArray = [payload];
          this.resultsSearch._setPayload(payloadArray);
          localStorage.setItem('form', JSON.stringify(form));
          localStorage.setItem('payload', JSON.stringify(payloadArray));
          this.resultsSearch._setOrigin(item.categoryName);

          this._setSearchIdInResults(response);
          if (response.results.length > 0) {
            this._handleResponse(response, item.categoryName, item);
            this.dialog.closeAll();
            this.itineraryService.notifyModalClosed(true);
            if(item.category_id === 1) {
                this.resultsSearch.emitReloadSearchHotel();
              }
            this.router.navigate(['/results']);
          } else {
            const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
              height: 'auto',
              width: '350px',
              data: 'No se encontraron Resultados',
              disableClose: true,
            });
          }
        }
      },
      (error) => {
        const message = 'Ocurrió un error al intentar encontrar productos';
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
          width: '450px',
          data: { message },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.makePayload(item);
          } else {
            this.dialog.closeAll();
          }
        });
      }
    );
  }

  _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = 'No results found for the search';
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log('error', e);
      }
    }
  }

  /// modal loading
  openModalLoading(data: any) {
    const dialogRef = this.dialog.open(ModalLoadingComponent, {
      width: '650px',
      id: 'loadModal',
      data,
      disableClose: true,
    });

    /* dialogRef.afterClosed().subscribe(result => {
            });*/
  }

  returnDate(date: any) {
    const dateSplit = date.split('-');
    return (
      '' +
      dateSplit[2] +
      '-' +
      moment()
        .month(parseInt(dateSplit[1]) - 1)
        .format('MMM')
    );
  }

  suggestionsCategories(event: any): void {
    if (event) {
      this.suggestions = event;
    }
  }

  getTotalTarifa() {
    // El backend ya trae el total neto calculado a nivel itinerario. No todos los items
    // tienen item.netPriceAgent propio (p. ej. hoteles, donde el neto vive en
    // item.profility.netPriceBooking), así que calculateTotal('netPriceAgent') los
    // contaba como 0. Mismo patrón que summary-reservation.component.ts:72.
    // let price = parseFloat(this.itinerary?.totalNetPriceAgent) || 0;
    let price = this.calculateTotal('netPriceAgent');
    // Impuestos no incluidos (a pagar en destino) — no forman parte de totalNetPriceAgent,
    // así que se convierten y suman acá aparte, con la misma matemática de conversión
    // que usa ItineraryService.calculateTotal(). Solo hoteles, solo para mostrar.
    price += this.calculateHotelTaxesExcluded();

    return price;
  }

  private calculateTotal(fieldName: string): number {

      return this.itineraryService.calculateTotal(
                                                fieldName,
                                                this.itinerary,
                                                this.currencies,
                                                this.currencyAgency);
  }

  private calculateHotelTaxesExcluded(): number {
    const agencyRate = parseFloat(this.currencyAgency?.rate);
    if (!this.itinerary?.items?.length || !(agencyRate > 0)) {
      return 0;
    }

    const currencyRates = new Map(
      (this.currencies || []).map((c: any) => [c.code, parseFloat(c.rate)])
    );

    return this.itinerary.items
      .filter((item: any) => item.status_id !== 5 && (item.category_id === 1 || item.categoryId === 1))
      .reduce((sum: number, item: any) => {
        const taxesExcluded = item.room?.pricing?.taxesExcluded || 0;
        if (!taxesExcluded) {
          return sum;
        }
        // Misma moneda que la agencia: sumar directo, sin ida y vuelta de conversión
        // (evita el mismo problema de doble conversión que calculateTotal() ya tenía).
        if (this.currencyAgency?.code === item.currency) {
          return sum + taxesExcluded;
        }
        const itemRate = currencyRates.get(item.currency) || 0;
        return itemRate > 0 ? sum + (taxesExcluded / itemRate) * agencyRate : sum;
      }, 0);
  }

  DownloadItineraryQuote(id: number): void {
    this.itineraryService.itineraryDownload(id, this.getClientsSettingAppBooking.id, 'quote');
  }

  getPeriods(activities: any): any[] {
    return [
      { key: 'morning', label: 'Mañana', activities: activities.morning },
      { key: 'afternoon', label: 'Tarde', activities: activities.afternoon },
      { key: 'night', label: 'Noche', activities: activities.night },
    ];
  }

  getIndexDestination(day): boolean {
    return true;
  }

getItem(data: any): any {
  // Verificar que data existe y tiene item
  if (!data?.item) {
    return null;
  }

  // Si ya es un objeto, devolverlo directamente
  if (typeof data.item === 'object') {
    if(data.form) {
        return {...data.item, formData: data.form};
    }

    return data.item;
  }

  // Si es string, intentar parsear
  if (typeof data.item === 'string') {
    try {
      const item = JSON.parse(data.item);
      if(data.form) {
          return {...item, formData: data.form};
      }
      return item;
    } catch (error) {
      console.warn('Invalid JSON format:', data.item);
      return null;
    }
  }

  return null;
}

  /**
   * Devuelve las habitaciones parseadas de un hotel agrupado, o null si no está agrupado.
   * Se usa en el template porque Angular no soporta .map() con arrow functions en bindings.
   */
  getHotelRooms(activity: any): any[] {
    if (!activity?._groupedRooms) {
return null;
}
    return activity._groupedRooms.map(r => this.getItem(r));
  }

  /**
   * Devuelve el Observable con la URL de imagen hero del destino en `indexDestination`.
   * Si el summary ya trae `inmg_zones[0]` con contenido, NO llama al backend.
   * Si no, busca el `id` numérico del destino en el primer activity del día 1
   * y consulta el endpoint `/itineraries/destination-images`.
   */
  heroImageFor(indexDestination: number): Observable<string | null> {
    const dest = this.summaryItinerary?.[indexDestination];
    if (!dest) {
      return of(null);
    }

    // Si el summary ya trae imagen propia, no tocamos nada.
    if (Array.isArray(dest.inmg_zones) && dest.inmg_zones.length > 0 && dest.inmg_zones[0]) {
      return of(null);
    }

    const destinationForm = dest?.days?.[0]?.parsedPeriods?.[0]?.activities?.[0]?.activity?.form?.destination;
    const destinationId = destinationForm?.id ?? destinationForm?.destination_id;
    const cityId = destinationForm?.city_id ?? destinationForm?.city?.id;
    const countryId = destinationForm?.country_id ?? destinationForm?.country?.id;
    const cityIataCode = destinationForm?.city_iata_code;
    const countryIataCode = destinationForm?.country_iata_code;
    if (!destinationId && !cityId && !countryId && !cityIataCode && !countryIataCode) {
      return of(null);
    }

    return this.destinationImageService.getImageByDestinationId(
      destinationId,
      cityId,
      countryId,
      cityIataCode,
      countryIataCode,
    );
  }

  reloadEmmit(): void {
    this.reloadSummaryItinerary.emit();
  }

  toggleMap(): void {
    this.mapVisible = !this.mapVisible;

    if (this.mapVisible) {
      this.buildMapCoordinates();
    }
  }

  private buildMapCoordinates(): void {
    const allCoordinates: any[] = [];

    this.summaryItinerary.forEach((destination, index) => {
      const cityName = destination.city_name || '';
      const mainCityName = cityName.split(',')[0].trim();

      allCoordinates.push({
        name: mainCityName,
        fullName: cityName,
        type: 'city',
        description: cityName,
        city: destination.iata_code,
        iata: destination.iata_code,
        order: index
      });
    });

    this.mapCoordinates = [...allCoordinates];
  }

/**
 * Método para obtener la imagen del logotipo de la agencia.
 *
 * Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
 * Si la imagen no está disponible o es igual a la ruta del archivo de la API,
 * retorna una imagen por defecto.
 *
 * @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
 */
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

 getPaymentConditions(agency: any) {
        this._restService.doGet('app', 'agencyPaymentCondition/list?').subscribe({
          next: (response: any) => {
            if(response) {
              this.paymentConditions = response;
              this.availablePaymentConditions(this.paymentConditions, agency);
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log('No existe informacion, Condición de Pagos!', error);
          }
        });
      }

      private availablePaymentConditions(dataPaymentCondition: any, agency: any) {
        const payAgencyActive = dataPaymentCondition.find(c => c.id === agency.pay_mode);
        this.paymentAgencyActive = payAgencyActive;
        this.paymentAgencyActiveLoaded = true;
      }


      suggestionAdd(): void {
        this.reloadEmmit();
      }

toggleInsurances(day: any): void {
    day._insurancesExpanded = !day._insurancesExpanded;
  }

  toggleEndedInsurances(day: any): void {
    day._insurancesEndedExpanded = !day._insurancesEndedExpanded;
  }

  getDay(dateDay: string): string {
    if (!dateDay) {
return '';
}
    return dateDay.split('-')[0].trim();
  }

    getSuggestion(item: any): void {
    }

        applyImageFilter() {
            const color = '#fe2e54';
            const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

            //Extraemos el literal en String de la conversión
            const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(' ');

            // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
            const colorRegex = /color\((.*)\)/;
            const colorMatch = tempFilterStr.match(colorRegex);
            const colorFilter = colorMatch ? colorMatch[1] : '';

            this.filterColorIcon = colorFilter;

            // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
            setTimeout(() => {
              this.iconsCheckOut?.forEach(icon => {
                icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 25px;`);
              });
            }, 100);
          }
}
